import { Typography } from '@mui/material'
import React, { FC } from 'react'

export const Copyright: FC = () => {
  return (
    <Typography variant="caption" color="textSecondary" align="center">
      {`Copyright © Medilab. ${new Date().getFullYear()} ver.2.0.0`}
    </Typography>
  )
}
